import { Typography } from '@mui/material';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import React from 'react';


interface DataItem {
    name: string;
    period: string;
    values: ValueItem[];
    title: string;
    description: string;
    id: string;
}

interface ValueItem {
    value: object;
    numberValue: number;
    decimalValue: number;
}

interface UserInsightProps {
    insightsData?: DataItem[] | null;
}

const InstagramUserInsights: React.FC<UserInsightProps> = ({ insightsData }) => {

    return (
        <Grid container spacing={3} sx={{ mt: 3 }}>
            {insightsData?.map((item, index) => (
                <Grid item xs={12} sm={4} key={index}>
                    <Card sx={{ padding: '20px', borderRadius: '10px', boxShadow: 3 }}>
                        <Typography variant="subtitle1" gutterBottom>
                            {item.title ? item.title : item.name}
                        </Typography>
                        <Typography variant="h5" style={{ marginBottom: '8px', color: '#3f51b5' }}>
                            <strong>{item.values.map((valueItem, i) => (
                                <>
                                    {valueItem.numberValue ? valueItem.numberValue : valueItem.decimalValue}
                                    {item.name === "engagement_rate" && !valueItem.numberValue && '%'}
                                </>
                            ))}
                            </strong>
                        </Typography>
                    </Card>
                </Grid>
            ))}
        </Grid>
    )
}


export default React.memo(InstagramUserInsights);